import {AppRouter} from "../../index";

export const RouterMiddleware = (store) => (next) => (action) => {
    let result = next(action);
    AppRouter.check(store.getState().router, action.type);
    return result;
}